import { render, staticRenderFns } from "./documentAnalysis.vue?vue&type=template&id=456371d0&"
import script from "./documentAnalysis.vue?vue&type=script&lang=js&"
export * from "./documentAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./documentAnalysis.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports